import React from "react";
import { ApparecchioCategory, IAggiornaDateControlloData, ImpiantoDto, ImpiantoLight } from "../../generated";
import DatesHelper from "../../common/datesHelper";
import ImpiantiStore from "../ImpiantiTermiciStore";
import { Loading } from "../../common/components/loading";
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import StringsHelper from "../../common/stringsHelper";
import BolliniVerdiHelper from "../../bolliniVerdi/BolliniVerdiHelper";
import { RapportoControlloModalSelector } from "../../rapporticontrollo/components/rapportoControlloModalSelector";
import OpenModalButton from "../../common/components/openModalButton";
import ImpiantiHelper from "../ImpiantiHelper";
import { AggiornaDateControlloForm } from "./aggiornaDateControlloForm";
import BolliniVerdiStore from "../../bolliniVerdi/BolliniVerdiStore";
import CaldaiaData from "../../caldaie/components/caldaiaData";
import ApparecchioTypeIcon from "./apparecchioTypeIcon";
import DeleteImpiantoButton from "./deleteImpiantoButton";
import ImpiantiTermiciActions from "../ImpiantiTermiciActions";
import { ToImpiantoData } from "./impiantoForm";
import { withApparecchioCateogories } from "../withApparecchioCategories";
import { Dictionary } from "../../common/AbstractStores";
interface Props {
    impiantoData: ImpiantoLight;
    apparecchioCategories: Dictionary<ApparecchioCategory>
}
export const ImpiantoWidget = withApparecchioCateogories((props: Props) => {
    const { idCliente, id, type } = props.impiantoData;
    const impianto = ImpiantiStore.use(id);

    const bolliniImpianto = BolliniVerdiStore.useForImpianto(id);
    if (!impianto)
        return <Loading />

    let aggiornaDateControlloModal = React.createRef<OpenModalButton>();
    const changeCheckDate = async (data: IAggiornaDateControlloData) => {
        aggiornaDateControlloModal.current?.close();
        await ImpiantiHelper.evadiScadenze([impianto], data, props.apparecchioCategories);
    }

    const onRestoreImpianto = async (impianto: ImpiantoDto) => {
        impianto.dismesso = false;
        await ImpiantiTermiciActions.update(ToImpiantoData(impianto), impianto.idImpianto);
    }


    const ultimoBollino = BolliniVerdiHelper.getLast(bolliniImpianto);
    const bollinoExpired = ultimoBollino == null || BolliniVerdiHelper.isExpired(ultimoBollino);

    return (
        <div className="card" style={{ width: 400 }}>
            <div className="card-body">
                <div className="row align-items-center justify-content-center">
                    <div className="col-auto">
                        <div className="card-img p-2" style={{ width: 50, height: 50 }}>
                            <ApparecchioTypeIcon apparecchioType={type} color={impianto.dismesso ? "#fc4b6c" : undefined} height={50} width={50} />
                        </div>
                    </div>
                    <div className="col position-relative" style={{ lineHeight: 1.2 }}>
                        <Link className="stretched-link" to={links.impiantoEdit(id)} />
                        <div className="row no-gutter">
                            <span className="col d-flex text-uppercase flex-wrap align-items-center">
                                <CaldaiaData
                                    id={impianto.idCaldaia}
                                    template={c => <>
                                        <h3 className={`mb-0 me-1 ${impianto.dismesso ? "text-danger" : ""}`}>{c.marcaCaldaia}</h3>
                                        <h4 className={`mb-0 me-2 ${impianto.dismesso ? "text-danger" : ""}`}>{c.modelloCaldaia}</h4>
                                    </>}
                                />
                                {
                                    impianto.dismesso && <div className="row no-gutter text-end text-danger">
                                        <div className="col-12">
                                            <span className="badge bg-danger" style={{ fontSize: "1rem" }}>
                                                Dismesso
                                            </span>
                                        </div>
                                    </div>
                                }
                            </span>
                            <span className="col-auto ms-auto">
                                <i className="fas fa-fire text-primary" /> <span title="Potenza Utile">
                                    <CaldaiaData
                                        id={impianto.idCaldaia}
                                        template={c => <>{c.potenzaUtile && c.potenzaUtile > 0
                                            ? StringsHelper.toDecimalString(c.potenzaUtile)
                                            : "N.C."} KW
                                        </>
                                        }
                                    />
                                </span>
                            </span>
                        </div>
                        <div className="row no-gutter">
                            <div className="col d-flex justify-content-between">
                                <div className="d-flex flex-column">
                                    {impianto.matricola && <>
                                        <small><strong>Matricola </strong></small>
                                        {impianto.matricola}
                                    </>}
                                </div>
                                <div className="d-flex flex-column text-end">
                                    {impianto.codiceImpiantoCatasto && <>
                                        <small><strong>Cod.Targa </strong></small>
                                        {impianto.codiceImpiantoCatasto}
                                    </>}
                                </div>
                            </div>
                        </div>
                        <div className="row no-gutter">
                            <div className="col d-flex justify-content-between flex-wrap">
                                <div className="d-flex flex-column">
                                    <small><strong>Ult.Annuale </strong></small>
                                    {DatesHelper.getReadableDateString(impianto.dataUltimoControlloAnn)}
                                </div>
                                <div className="d-flex flex-column">
                                    <small><strong>Ult.Comb. </strong></small>
                                    {DatesHelper.getReadableDateString(impianto.dataUltimoControlloComb)}
                                </div>
                                {ultimoBollino && <div className="d-flex flex-column text-end">
                                    <small><strong>Bollino</strong></small>
                                    <span className={bollinoExpired ? "badge bg-danger" : "badge bg-success"}>{DatesHelper.getReadableCompactDateString(ultimoBollino.validity.from)}-{DatesHelper.getReadableCompactDateString(ultimoBollino.validity.to)}</span>
                                </div>}
                            </div>
                        </div>
                        {impianto.noteImpianto && <div><small>Nota: {impianto.noteImpianto}</small></div>}
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <div className="row justify-content-center align-items-center">
                    <div className="col-auto">
                        <RapportoControlloModalSelector
                            idImpianto={impianto.idImpianto}
                            idCliente={idCliente}
                            className="btn btn-outline-secondary me-1"
                        />
                        {!impianto.dismesso && <OpenModalButton
                            ref={aggiornaDateControlloModal}
                            title="Aggiorna date controllo"
                            className="btn btn-outline-secondary me-1"
                            modalContent={
                                <AggiornaDateControlloForm
                                    impiantiIds={[impianto.idImpianto]}
                                    onSubmit={changeCheckDate}
                                />
                            }>
                            <i className="fas fa-calendar" />  <span className="hidden-sm-down">Agg.Scadenze</span>
                        </OpenModalButton>}
                        {impianto.dismesso && <button className="btn btn-success" onClick={() => onRestoreImpianto(impianto)}>
                            <i className="fas fa-check-square" /> <span className="hidden-sm-down">Ripristina</span>
                        </button>}
                        {!impianto.dismesso && <DeleteImpiantoButton impianto={impianto} />}
                    </div>
                </div>
            </div>
        </div >
    );
})(x => x.allByKey(), "apparecchioCategories");